<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].header }} {{ setUppercase(bank_code) }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative">
        <div class="w-full flex flex-column max-w-30rem relative
            surface-0 xl:surface-100 lg:surface-100 md:surface-100
            border-round-2xl 
            p-3 xl:p-4 mb-1 xl:mb-5">
            <!--ACCOUNT NUMBER-->
            <span v-if="account_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].account_number }}:
            </span>
            <span v-if="account_number" class="flex text-xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ account_number }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(account_number)"></span>
            </span>

            <!--FULLNAME-->
            <span v-if="fullname" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].fullname }}:
            </span>
            <span v-if="fullname" class="flex text-sm xl:text-lg font-medium text-900">
                <span>{{ fullname }}</span>
            </span>

            <!--TELEGRAM-->
            <span v-if="telegram" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].telegram }}:
            </span>
            <span v-if="telegram" class="flex text-xl xl:text-3xl font-medium text-900">
                <span>{{ telegram }}</span>
            </span>
            <div v-if="bank_image" class="absolute flex deep_white_shadow right-0 bottom-0 surface-0 mr-3 mb-3 border-circle align-items-center justify-content-center text-center">
                <Avatar :image="bank_image" size="medium" shape="circle" class="flex" />
            </div>
        </div>

        <div class="w-full flex flex-column max-w-30rem relative py-1 xl:py-0 xl:px-8">
            <InlineMessage severity="success" class="border-round-2xl line-height-2 text-xs xl:text-md border-none">
                {{ content[lang_].make_sure_1 }} 
            </InlineMessage>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
export default {
    props: [
        'bank_code',
        'bank_title',
        'bank_image',
        'account_number',
        'fullname',
        'telegram',
    ],
	data(){
		return{
			content: {
				en: {
					header: 'As payment, make a transfer by details to the account ',
                    account_number: 'Account number',
                    fullname: 'Name',
                    telegram: 'Telegram',
                    make_sure_1: 'Pay the transfer by transferring USDT to the Account number',
                    copied: 'Copied'
				} ,
				ru: {
					header: 'В качестве оплаты совершите перевод по реквизитам на аккаунт ',
                    account_number: 'Номер аккаунта',
                    fullname: 'Имя',
                    telegram: 'Telegram',
                    make_sure_1: 'Оплатите трансфер переводом USDT по Номеру аккаунта',
                    copied: 'Скопировано'
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        setUppercase(text){
            if(!text) return ''
            return text.toUpperCase()
        },
	},
	beforeCreate() {
        this.helper = new Helper()    
	}
}
</script>